var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMargin03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 117,
    viewBox: "0 0 157 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M120.77 2H36V115.21H120.77V2Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M120.78 86.0508H154.78V115.221H2V86.0508H36",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M78.3904 95.8003C91.5016 95.8003 102.13 85.1716 102.13 72.0603C102.13 58.9491 91.5016 48.3203 78.3904 48.3203C65.2791 48.3203 54.6504 58.9491 54.6504 72.0603C54.6504 85.1716 65.2791 95.8003 78.3904 95.8003Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M86.3797 79.2711C86.3797 79.2711 88.9997 76.6111 88.9997 72.6111C88.9997 68.6111 86.9997 66.4611 83.9497 66.4611C80.8997 66.4611 79.6397 69.5611 78.6197 72.8711C77.5997 76.1811 75.9897 78.8011 73.3497 78.8011C70.7097 78.8011 68.4297 76.2611 68.4297 72.6211C68.4297 68.9811 71.3797 64.8711 71.3797 64.8711",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M93.3702 72.6113H63.4102",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M120.78 23.02C109.17 23.02 99.7598 13.61 99.7598 2",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M36 23.02C47.61 23.02 57.02 13.61 57.02 2",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M104.41 46.0098C107.15 46.0098 107.15 41.7598 104.41 41.7598C101.67 41.7598 101.67 46.0098 104.41 46.0098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M130.119 97.4004C132.859 97.4004 132.859 93.1504 130.119 93.1504C127.379 93.1504 127.379 97.4004 130.119 97.4004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M10.2601 101.4C13.0001 101.4 13.0001 97.1504 10.2601 97.1504C7.52008 97.1504 7.52008 101.4 10.2601 101.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M46.5101 57.1094C49.2501 57.1094 49.2501 52.8594 46.5101 52.8594C43.7701 52.8594 43.7701 57.1094 46.5101 57.1094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M19.8702 58.9903C23.0237 58.9903 25.5801 56.4339 25.5801 53.2803C25.5801 50.1268 23.0237 47.5703 19.8702 47.5703C16.7166 47.5703 14.1602 50.1268 14.1602 53.2803C14.1602 56.4339 16.7166 58.9903 19.8702 58.9903Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M7.70996 20.8204C10.8635 20.8204 13.42 18.2639 13.42 15.1104C13.42 11.9568 10.8635 9.40039 7.70996 9.40039C4.55642 9.40039 2 11.9568 2 15.1104C2 18.2639 4.55642 20.8204 7.70996 20.8204Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMargin03);
export default __webpack_public_path__ + "static/media/icon_margin_03.0e8814fb32fe9f0235020398568e176a.svg";
export { ForwardRef as ReactComponent };